import { useState, useEffect } from 'react';
import SubReasonService from '../service/SubReasonService';

export function useGetSubReason() {
  const [subReasonList, setSubReasonList] = useState([]);

  useEffect(() => {
    SubReasonService.getAll(1, 1000, {})
      .then((response) => {
        if (response.data.data.length > 0) {
          let reasonOptionList = response.data.data.map((reason) => {
            return { subMotive: reason.id, label: reason.name };
          });

          setSubReasonList(reasonOptionList);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    subReasonList,
    setSubReasonList
  };
}
